module.exports = __webpack_public_path__ + "media/images/games/k2reveal/pillar-dcdf151b7e911f289229566c60c3ba48.png";